import { render } from "./Pagination.vue?vue&type=template&id=641363b5"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "641363b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('641363b5', __exports__)) {
    api.reload('641363b5', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=641363b5", () => {
    api.rerender('641363b5', render)
  })

}


export default __exports__